let _cachedBaseDomain = null;

function isValidHostname(hostname) {
  if (!hostname || typeof hostname !== "string") return false;
  if (hostname.length > 253) return false;
  if (hostname.endsWith(".")) hostname = hostname.slice(0, -1);

  const labelRegex = /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/i;
  return hostname.split(".").every((label) => labelRegex.test(label));
}

function stripStagingPrefix(hostname) {
  const parts = hostname.split(".");
  if (/^staging(?:-[^.]+)?$/i.test(parts[0])) {
    parts.shift();
  }
  return parts.join(".");
}

export function resolveBaseDomain() {
  if (_cachedBaseDomain) return _cachedBaseDomain;

  function fallbackFromLocation() {
    if (typeof window === "undefined") return "unknown";
    const aud = window.location && window.location.host ? window.location.host : "unknown";
    const host = aud.includes(":") ? aud.split(":")[0] : aud;
    let base = host;
    base = stripStagingPrefix(base);
    if (base === "localhost" || base === "127.0.0.1") base = "getmytestdomain.com";
    _cachedBaseDomain = base;
    return base;
  }

  if (typeof window !== "undefined" && window.domain_replacer && window.domain_replacer.domain) {
    let candidate = String(window.domain_replacer.domain || "").trim();

    if (!candidate) return fallbackFromLocation();

    try {
      const url = new URL(candidate.includes("://") ? candidate : `https://${candidate}`);
      let hostname = url.hostname;
      hostname = hostname.toLowerCase();

      if (hostname.endsWith(".")) hostname = hostname.slice(0, -1);

      hostname = stripStagingPrefix(hostname);

      if (hostname === "localhost" || hostname === "127.0.0.1") {
        _cachedBaseDomain = "getmytestdomain.com";
        return _cachedBaseDomain;
      }

      if (!isValidHostname(hostname)) {
        if (process && process.env && process.env.NODE_ENV !== "production") {
          console.warn("[resolveBaseDomain] rejected invalid hostname from domain_replacer:", candidate);
        }
        return fallbackFromLocation();
      }

      _cachedBaseDomain = hostname;
      return hostname;
    } catch (e) {
      return fallbackFromLocation();
    }
  }

  return fallbackFromLocation();
}

export function videoSrc(videoId) {
  const baseDomain = resolveBaseDomain();
  const cdnBase = `https://cdn.${baseDomain}`;

  const normalized = String(videoId || "").replace(/^\/+/, "");
  const hasExt = /\.mp4(?:\?.*)?$/i.test(normalized);
  const path = `/${hasExt ? normalized : `${normalized}.mp4`}`;

  return `${cdnBase}${path}`;
}

export function thumbnailSrc(videoId, ext = "webp") {
  const baseDomain = resolveBaseDomain();
  const cdnBase = `https://cdn.${baseDomain}`;
  const cleanExt = String(ext || "webp").replace(/^\./, "");
  const normalized = String(videoId || "").replace(/^\/+/, "");
  return `${cdnBase}/streamsMigration/thumbnails/${normalized}.${cleanExt}`;
}
